$(function(){

    $(".slim-ex").each(function(){
        var el = this;
        var name = $(this).find("input[type=file]").attr("name");
        var exImage = $(this).find("img");
        var media_id = null;
        var removeAttr = null;
        if(exImage.length) {
            var src= $(exImage).attr("src");
            try {
                src = src.split("?")[0].split("/").reverse()[0].split("_")[0];
            } catch (e) {
                src = null;
            }
            if(src) {
                media_id = src;
            }
        }
        var meta = {
        };
        if(media_id) {
            meta.media_id = media_id;
        }

        var opts={
            meta:meta,
            download:true,
            push:true,
            didLoad:function(data,canvas,ready) {
                if(removeAttr) {
                    removeAttr.remove();
                    removeAttr = null;
                }
                $('form').attr('data-dirty','true');

                return true;
            },
            didRemove: function(ready) {
                removeAttr = $('<input type="hidden"/>');
                removeAttr.attr("name",name);
                removeAttr.val(JSON.stringify({
                    action:'delete',
                    media_id:meta?meta.media_id:''
                }));
                $(el).append(removeAttr);
                $('form').attr('data-dirty','true');
            },
        };
        $(el.attributes).each(function() {
            if(this.nodeName.indexOf('data-')===-1) {
                return;
            }
            var name = this.nodeName.replace('data-','').split('-');
            for(var i =0;i<name.length;i++ ) {
                if(i) {
                    name[i] = name[i].substr(0, 1).toUpperCase() + name[i].substr(1);
                }else{
                    name[i] = name[i];
                }
            }
            name=name.join('');
            if(this.nodeValue==="true") {
                this.nodeValue = true;
            }

            if(name==='ratio') {
                opts[name] = this.nodeValue;
            }else if(name==='size') {
                var s = this.nodeValue.split(",");
                opts[name] = {
                    width:s[0],
                    height:s[1]
                } ;
            } else{
                opts[name] = this.nodeValue;
            }
        });

        console.log("OPTS OPTS OPTS ", opts);

        el.slim = new Slim(el, opts);
    });

});